/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RefundSplitDto } from './RefundSplitDto';
import {
    RefundSplitDtoFromJSON,
    RefundSplitDtoFromJSONTyped,
    RefundSplitDtoToJSON,
    RefundSplitDtoToJSONTyped,
} from './RefundSplitDto';

/**
 * 
 * @export
 * @interface InitiateRefundRequest
 */
export interface InitiateRefundRequest {
    /**
     * 
     * @type {number}
     * @memberof InitiateRefundRequest
     */
    refundAmount?: number;
    /**
     * 
     * @type {Array<RefundSplitDto>}
     * @memberof InitiateRefundRequest
     */
    refundSplits?: Array<RefundSplitDto>;
    /**
     * 
     * @type {InitiateRefundRequestRefundSplitDistributionTypeEnum}
     * @memberof InitiateRefundRequest
     */
    refundSplitDistributionType: InitiateRefundRequestRefundSplitDistributionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof InitiateRefundRequest
     */
    clientRefundReference?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiateRefundRequest
     */
    terminalId?: string;
}


/**
 * @export
 */
export const InitiateRefundRequestRefundSplitDistributionTypeEnum = {
    CUSTOM_SPLIT_DISTRIBUTION: 'CUSTOM_SPLIT_DISTRIBUTION',
    FULL_REFUND_ACCORDING_TO_PAYMENT_SPLITS: 'FULL_REFUND_ACCORDING_TO_PAYMENT_SPLITS'
} as const;
export type InitiateRefundRequestRefundSplitDistributionTypeEnum = typeof InitiateRefundRequestRefundSplitDistributionTypeEnum[keyof typeof InitiateRefundRequestRefundSplitDistributionTypeEnum];


/**
 * Check if a given object implements the InitiateRefundRequest interface.
 */
export function instanceOfInitiateRefundRequest(value: object): value is InitiateRefundRequest {
    if (!('refundSplitDistributionType' in value) || value['refundSplitDistributionType'] === undefined) return false;
    return true;
}

export function InitiateRefundRequestFromJSON(json: any): InitiateRefundRequest {
    return InitiateRefundRequestFromJSONTyped(json, false);
}

export function InitiateRefundRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InitiateRefundRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'refundAmount': json['refundAmount'] == null ? undefined : json['refundAmount'],
        'refundSplits': json['refundSplits'] == null ? undefined : ((json['refundSplits'] as Array<any>).map(RefundSplitDtoFromJSON)),
        'refundSplitDistributionType': json['refundSplitDistributionType'],
        'clientRefundReference': json['clientRefundReference'] == null ? undefined : json['clientRefundReference'],
        'terminalId': json['terminalId'] == null ? undefined : json['terminalId'],
    };
}

export function InitiateRefundRequestToJSON(json: any): InitiateRefundRequest {
    return InitiateRefundRequestToJSONTyped(json, false);
}

export function InitiateRefundRequestToJSONTyped(value?: InitiateRefundRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'refundAmount': value['refundAmount'],
        'refundSplits': value['refundSplits'] == null ? undefined : ((value['refundSplits'] as Array<any>).map(RefundSplitDtoToJSON)),
        'refundSplitDistributionType': value['refundSplitDistributionType'],
        'clientRefundReference': value['clientRefundReference'],
        'terminalId': value['terminalId'],
    };
}

